import slugify from "slugify";

export {
  createSalesAgentSessionMetadata,
  createSessionTitle,
  defaultSalesAgentModelOptionId,
  emptyChatMessageParts,
  formatSessionDate,
  getSalesAgentModelOption,
  isSalesAgentModelOptionId,
  salesAgentChatType,
  salesAgentModelOptions,
  salesAgentSuggestions,
  sessionsQueryKey,
  type SalesAgentModelOptionId,
} from "@fitness-app/client-shared/features/sales-agent";

export type SkillFormValues = {
  name: string;
  slug: string;
  description: string;
  content: string;
  enabled: boolean;
  sortOrder: number;
};

export const skillsQueryKey = ["salesAgentSkills"];

export const defaultSkillContent = `# Nowy skill sprzedażowy

## Kiedy używać
- Opisz sytuację na rozmowie, w której agent ma zastosować ten skill.

## Instrukcja dla agenta
- Dodaj konkretne kroki, argumenty i pytania.
- Pisz tak, jak ma działać sprzedawca na rozmowie.
`;

export const getClientWebApiBaseUrl = () => import.meta.env.VITE_BACKGROUND_TASKS_API_URL?.replace(/\/$/, "");

/**
 * TRE-1911 — przełącznik transportu czatu agenta: flaga ON = durable
 * /api/sales-agent/chat-workflow (wznawianie streamu, server-side cancel),
 * OFF = legacy /api/sales-agent/chat. Kill-switch na wypadek problemów z
 * workflow — wyłączenie flagi w PostHogu cofa admina na starą ścieżkę bez
 * deploya (obowiązuje od następnego załadowania widoku).
 */
export const SALES_AGENT_WORKFLOW_TRANSPORT_FLAG = "sales-agent-workflow-transport";

export const createSlug = (name: string) => slugify(name, { lower: true, strict: true, locale: "pl" });
